import { styled } from '@mui/material';

import { useEffect } from 'react';

import { useI18n } from '@app-velocity/i18n';
import { Button, Card, Typography } from '@app-velocity/ui';

import { useTeamAdminContext } from '../../../../../../context';
import { useBuyCreditsForTeamMutation } from '../../../../../../query';

export type TopUpProps = {
  amount: number;
  price: number;
};

const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: theme.spacing(1),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

const StyledTypography = styled(Typography)({
  fontSize: 14,
});

export const TopUp = ({ amount, price }: TopUpProps) => {
  const { t } = useI18n();
  const { team } = useTeamAdminContext();

  const {
    mutate: getPaymentLink,
    isPending,
    data: paymentLink,
    isSuccess,
  } = useBuyCreditsForTeamMutation(team.id!);

  const handleClick = () => {
    getPaymentLink();
  };

  useEffect(() => {
    if (!isSuccess || !paymentLink) return;
    window.open(paymentLink.paymentUrl, '_blank');
  }, [isSuccess, paymentLink]);

  return (
    <StyledCard>
      <StyledTypography>
        {t('teams:usage.simulations.n_for_m', {
          amount,
          price: `$${price}`,
          interpolation: { escapeValue: false },
        })}
      </StyledTypography>
      <Button
        variant="contained"
        color="primary"
        size="small"
        onClick={handleClick}
        disabled={isPending}
      >
        {t('teams:usage.simulations.buy_pack')}
      </Button>
    </StyledCard>
  );
};
